import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import Testimonials from "./Testimonials";
import reviews from "./data";

function Testimonial2() {
  const videoId = "5mPU-mIQgoQ";
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={12} className="home-testimonial">
            <h1>TESTIMONIALS</h1>
          </Col>
          <Col md={12} className="testimonials">
            <Testimonials reviews={reviews}/>              
          </Col>          
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>OUR INTERNSHIP PROGRAM</h1>
            <Container>
              <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                <iframe
                  title="YouTube video"
                  src={`https://www.youtube.com/embed/${videoId}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                  }}
                />
              </div>
            </Container>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Testimonial2;
